import { pages, subPackages, tabBar } from '@/pages.json'
import { isMp } from './platform'
import qs from 'qs'

const getLastPage = () => {
  // getCurrentPages() 至少有1个元素，所以不再额外判断
  // const lastPage = getCurrentPages().at(-1)
  // 上面那个在低版本安卓中打包回报错，所以改用下面这个【虽然我加了src/interceptions/prototype.ts，但依然报错】
  const pages = getCurrentPages()
  return pages[pages.length - 1]
}

/** 判断当前页面是否是tabbar页  */
export const getIsTabbar = () => {
  if (!tabBar) {
    return false
  }
  if (!tabBar.list.length) {
    // 通常有tabBar的话，list不能有空，且至少有2个元素，这里其实不用处理
    return false
  }
  const lastPage = getLastPage()
  const currPath = lastPage.route
  return !!tabBar.list.find((e) => e.pagePath === currPath)
}

/**
 * 获取当前页面路由的 path 路径和 redirectPath 路径
 * path 如 ‘/pages/login/index’
 * redirectPath 如 ‘/pages/demo/base/route-interceptor’
 */
export const currRoute = () => {
  const lastPage = getLastPage()
  const currRoute = (lastPage as any).$page
  // 经过多端测试，只有 fullPath 靠谱，其他都不靠谱
  const { fullPath } = currRoute as { fullPath: string }
  // eg: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor (小程序)
  // eg: /pages/login/index?redirect=%2Fpages%2Froute-interceptor%2Findex%3Fname%3Dfeige%26age%3D30(h5)
  return getUrlObj(fullPath)
}

const ensureDecodeURIComponent = (url: string) => {
  if (url.startsWith('%')) {
    return ensureDecodeURIComponent(decodeURIComponent(url))
  }
  return url
}
/**
 * 解析 url 得到 path 和 query
 * 比如输入url: /pages/login/index?redirect=%2Fpages%2Fdemo%2Fbase%2Froute-interceptor
 * 输出: {path: /pages/login/index, query: {redirect: /pages/demo/base/route-interceptor}}
 */
export const getUrlObj = (url: string) => {
  const [path, queryStr] = url.split('?')

  if (!queryStr) {
    return {
      path,
      query: {},
    }
  }
  const query: Record<string, string> = {}
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    query[key] = ensureDecodeURIComponent(value) // 这里需要统一 decodeURIComponent 一下，可以兼容h5和微信y
  })
  return { path, query }
}
/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 这里设计得通用一点，可以传递key作为判断依据，默认是 needLogin, 与 route-block 配对使用
 * 如果没有传 key，则表示所有的pages，如果传递了 key, 则表示通过 key 过滤
 */
export const getAllPages = (key = 'needLogin') => {
  // 这里处理主包
  const mainPages = [
    ...pages
      .filter((page) => !key || page[key])
      .map((page) => ({
        ...page,
        path: `/${page.path}`,
      })),
  ]
  // 这里处理分包
  const subPages: any[] = []
  subPackages.forEach((subPageObj) => {
    const { root } = subPageObj

    subPageObj.pages
      .filter((page) => !key || page[key])
      .forEach((page: { path: string } & Record<string, any>) => {
        subPages.push({
          ...page,
          path: `/${root}/${page.path}`,
        })
      })
  })
  const result = [...mainPages, ...subPages]
  return result
}

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const getNeedLoginPages = (): string[] => getAllPages('needLogin').map((page) => page.path)

/**
 * 得到所有的需要登录的pages，包括主包和分包的
 * 只得到 path 数组
 */
export const needLoginPages: string[] = getAllPages('needLogin').map((page) => page.path)

/**
 * 根据微信小程序当前环境，判断应该获取的BaseUrl
 */
export const getEvnBaseUrl = () => {
  // 请求基准地址
  let baseUrl = import.meta.env.VITE_SERVER_BASEURL

  // 小程序端环境区分
  if (isMp) {
    const {
      miniProgram: { envVersion },
    } = uni.getAccountInfoSync()

    switch (envVersion) {
      case 'develop':
        baseUrl = 'https://ukw0y1.laf.run'
        break
      case 'trial':
        baseUrl = 'https://ukw0y1.laf.run'
        break
      case 'release':
        baseUrl = 'https://ukw0y1.laf.run'
        break
    }
  }

  return baseUrl
}

/**
 * 根据微信小程序当前环境，判断应该获取的UPLOAD_BASEURL
 */
export const getEvnBaseUploadUrl = () => {
  // 请求基准地址
  let baseUploadUrl = import.meta.env.VITE_UPLOAD_BASEURL

  // 小程序端环境区分
  if (isMp) {
    const {
      miniProgram: { envVersion },
    } = uni.getAccountInfoSync()

    switch (envVersion) {
      case 'develop':
        baseUploadUrl = 'https://ukw0y1.laf.run/upload'
        break
      case 'trial':
        baseUploadUrl = 'https://ukw0y1.laf.run/upload'
        break
      case 'release':
        baseUploadUrl = 'https://ukw0y1.laf.run/upload'
        break
    }
  }

  return baseUploadUrl
}

export function obj2Param(obj = {}) {
  return qs.stringify(obj)
}
// 日期格式化
export function parseTime(time: string | number | Date, pattern = '') {
  if (arguments?.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date: Date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time
        // eslint-disable-next-line prefer-regex-literals
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        // eslint-disable-next-line prefer-regex-literals
        .replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj: any = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result: string | any[], key: string) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', t('number.one'), t('number.two'), t('number.three'), t('number.four'), t('number.five'), t('number.six')][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

// 打开客服
export const openCustomerServiceChat = (url) => {
  console.log('url', url)

  uni.openCustomerServiceChat({
    extInfo: { url },
    corpId: 'ww1ddb9cf1f7306249',
    success(res) {
      console.log('失败==成功', res)
    },
    fail(res) {
      console.log('失败', res)
    },
  })
}

// 打开地图
export const openLocation = (longitude: number, latitude: number, address?: string) => {
  uni.openLocation({
    longitude, // 经度
    latitude, // 纬度
    address, // 地址的详细描述
    success() {
      console.log('地图打开成功')
    },
    fail(error) {
      console.error('地图打开失败', error)
    },
  })
}

// 获取酒店设施
export const getFieldsByCode = (code: string, limit?: number) => {
  if (!code) return []
  const fields = {
    '1': '免费wifi',
    '2': '收费wifi',
    '3': '免费宽带',
    '4': '收费宽带',
    '5': '免费停车场',
    '6': '收费停车场',
    '7': '免费接机服务',
    '8': '收费接机服务',
    '9': '室内游泳池',
    '10': '室外游泳池',
    '11': '健身房',
    '12': '商务中心',
    '13': '会议室',
    '14': '酒店餐厅',
    '15': '叫醒服务',
    '16': '行李寄存',
    '17': '双床',
    '18': '大床',
  }

  // 将字符串转换为数组，然后过滤出存在的字段
  const codes = code
    .split(',')
    // .map(Number)
    .filter((code) => fields[String(code)])

  // 获取对应的字段数组
  const result = codes.map((code) => fields[String(code)]).slice(0, limit)
  // console.log('sssssssss', code, result)

  return result
}
// 节流
export function useThrottle(fn, interval = 1000) {
  const lastExecRef = ref(Date.now())

  return function (...args) {
    const now = Date.now()
    if (now - lastExecRef.value >= interval) {
      lastExecRef.value = now
      fn(...args)
    }
  }
}

// 防抖
// export function useDebounce(fn, delay = 1000) {
//   let timeoutId = null

//   return function (...args) {
//     clearTimeout(timeoutId)
//     timeoutId = setTimeout(() => {
//       fn(...args)
//     }, delay)
//   }
// }
interface DebounceOptions {
  /**
   * 是否在延迟开始前立即执行（第一次调用立即触发）
   * @default false
   */
  leading?: boolean

  /**
   * 是否在延迟结束后执行最后一次调用
   * @default true
   */
  trailing?: boolean
}

/**
 * 防抖函数装饰器
 * @param func 需要防抖处理的函数
 * @param wait 延迟时间（毫秒）
 * @param options 配置选项
 * @returns 包装后的防抖函数及取消方法
 */
export function useDebounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
  options: DebounceOptions = {},
): {
  (this: ThisParameterType<T>, ...args: Parameters<T>): void
  cancel: () => void
} {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  let lastArgs: Parameters<T> | null = null
  let lastThis: ThisParameterType<T>
  let result: ReturnType<T>

  const { leading = false, trailing = true } = options

  // 实际执行的防抖函数
  function debounced(this: ThisParameterType<T>, ...args: Parameters<T>) {
    const context = this
    const timestamp = Date.now()
    lastArgs = args
    lastThis = context

    // 立即执行逻辑
    const callNow = leading && !timeoutId

    // 清除已有定时器
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    // 设置新定时器
    timeoutId = setTimeout(() => {
      timeoutId = null

      // 延迟后执行逻辑
      if (trailing && lastArgs) {
        result = func.apply(lastThis, lastArgs)
      }

      lastArgs = null
      lastThis = null!
    }, wait)

    // 立即执行
    if (callNow) {
      result = func.apply(context, args)
    }

    return result
  }

  // 取消方法
  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
      lastArgs = null
      lastThis = null!
    }
  }

  return debounced as any
}
export function downloadByUrl(url: string) {
  if (!url) return

  uni.showLoading({
    title: '正在下载中...',
  })

  uni.downloadFile({
    url, // 下载url
    filePath: `${wx.env.USER_DATA_PATH}/downFile.pdf`,
    success(res) {
      uni.hideLoading()
      uni.shareFileMessage({
        filePath: res.filePath,
        fileName: `${'发票'}.pdf`,
        success: () => {
          uni.showToast({
            title: '下载成功',
            icon: 'none',
          })
        },
        fail: (err) => {
          console.log('err', err)

          uni.showToast({
            title: '下载失败',
            icon: 'none',
          })
        },
      })
    },
    fail() {
      uni.hideLoading()
    },
  })
}

import { useOrderStore, useUserStore } from '@/store/index'
import { pollingMessage } from '@/service/order/order'

let timer = null
export const getSubMessage = () => {
  clearTimeout(timer)
  timer = null

  if (!useUserStore().isLogined) return

  timer = setTimeout(() => {
    if (!useUserStore().isLogined) {
      return getSubMessage()
    }
    pollingMessage().then((res) => {
      if (res.code === 200) {
        if (!!res.data && Object.keys(res.data)?.length > 0) {
          useOrderStore().subMessageData = res.data
          useOrderStore().showSubMessage = true
        }
      } else {
        uni.showToast({
          title: res.msg,
          icon: 'none',
        })
      }
      getSubMessage()
    })
  }, 20000)
}

// 导出富文本转换工具
export { transformRichText, transformRichTextWithConfig } from './richtext'
